/**
 * Stop Button Component
 *
 * Handles the submission of a stop word on a finish page. It imports a function called 
 * isTeamCaptain from a utility file and a FloatingInput component from another file. 
 * The component has a constructor that initializes the state with an empty string for 
 * the stop word. It has two methods, handleSubmit and handleUpdate, that respectively 
 * handle the submission of the stop word and update the state with the input value. 
 * The render method conditionally renders a form and a button if the user is a team 
 * captain. The form has an input field for the stop word and a submit button. When the 
 * form is submitted, the onSubmit function passed as a prop is called with the stop word 
 * as an argument.
 */

import React from 'react'
import { isTeamCaptain } from '../utils/team-data'
import FloatingInput from './floating-input'

export default class StopButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.state = {
      stopword: ``,
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    this.props.onSubmit(this.state.stopword)
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  render() {
    const isCaptain = isTeamCaptain()
    return (
      <div>
        {isCaptain && (
          <form
            className="form-block"
            method="post"
            onSubmit={event => {
              this.handleSubmit(event)
            }}>
            <FloatingInput
              name={`stopword`}
              placeholder={`Enter the Stop Word`}
              onChange={this.handleUpdate}
              value={this.state.stopword}
            />

            <button className={`btn btn-primary btn-block btn-arrow`} type="submit">
              Finished!
            </button>
          </form>
        )}
      </div>
    )
  }
}
